import { memo, useEffect } from "react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Controller, useForm } from "react-hook-form";
import { grey } from '@mui/material/colors';
import { CurrencyRupee } from '@mui/icons-material';
import { Grid, Stack, TextField, Divider, Chip, Button, Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { mainPaymentTypes, paymentTypes } from "utils/appConstants";

export const paymentStatusArray=[{name: 'Paid', value: 'paid'}, {name: 'Unpaid', value: 'unpaid'}];
const paymentTypeList = [...mainPaymentTypes, ...paymentTypes];


function FilterOptions({filters, applyFilters, closeModal, defaultFormFields}) {
  const { handleSubmit, control, formState: { errors }, reset, watch, setValue } = useForm({
    mode: 'onTouched',
    defaultValues: {...defaultFormFields, filters}
  });
  const paymentStatus = watch('status');

  function onSubmit(data) {
    applyFilters(data);
  }

  function resetFilters(){
    reset(defaultFormFields);
  }

  useEffect(() => {
    reset({...filters, paymentType:  filters?.paymentType || 'all'});
  }, [filters, reset]);
  

  return (
    <Box noValidate component="form" onSubmit={handleSubmit(onSubmit)} display="flex" >
      <Grid container  justifyContent="space-between" flexDirection="row"  spacing={2} flexGrow={1} >
        <Grid item xs={12} container spacing={2} flexDirection="row" alignContent="flex-start">
          <Grid item xs={12} >
            <Divider sx={{'::before, ::after':{borderColor: grey[200]}}}  aria-hidden="true" textAlign='left'>
              <Chip label="Date Range" size="small" sx={{borderRadius: 1, backgroundColor: grey[100]}} />
            </Divider>
          </Grid>
          <Grid item xs={12} sm={12} md={6} mt={1.5}>
            <Controller
              control={control}
              name="from"
              id="from"
              required
              rules={{
                required: true 
                // validate: (value) => !(isBefore(value, startOfDay(sub(new Date(), {months: 6})))) || "Past dates are not allowed",
                // validate: (value) => value?.getTime() >= watch('validityStartDate').getTime()  || "Validity End Date should be greater than Validity Start Date ",
              }}
              render={({field}) => (
                <LocalizationProvider dateAdapter={AdapterDateFns} >
                  <DatePicker
                    {...field}
                    required
                    label="Start date"
                    format="dd-MMM-yyyy"
                    clearable={false}
                    // disablePast // Need to enable after back date entries done
                    maxDate={watch('to')} // Need to disable after back date entries done
                    value={field.value}
                    onChange={(value) => {
                      field.onChange(value);
                    }}
                    openTo="day"
                    views={['year', 'month', 'day']}
                    textField={(params) => (
                      <TextField 
                        value={field.value}
                        {...params} 
                        margin="normal" 
                        sx={{width: '100%'}}
                      />
                    )}
                    slotProps={{
                      actionBar: {
                        // actions: ['today'],
                      },
                      textField: {
                        error: !!(errors?.from),
                        fullWidth: true
                      }
                    }}
                  />
                </LocalizationProvider>
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} mt={1.5}>
            <Controller
              control={control}
              name="to"
              id="to"
              required
              rules={{
                required: true 
                // validate: (value) => !(isBefore(value, startOfDay(sub(new Date(), {months: 6})))) || "Past dates are not allowed",
                // validate: (value) => value?.getTime() >= watch('validityStartDate').getTime()  || "Validity End Date should be greater than Validity Start Date ",
              }}
              render={({field}) => (
                <LocalizationProvider dateAdapter={AdapterDateFns} >
                  <DatePicker
                    {...field}
                    required
                    label="End date"
                    format="dd-MMM-yyyy"
                    clearable={false}
                    disableFuture
                    // disablePast // Need to enable after back date entries done
                    // minDate={field?.value || new Date()} // Need to disable after back date entries done
                    value={field.value}
                    onChange={(value) => {
                      field.onChange(value);
                    }}
                    openTo="day"
                    views={['year', 'month', 'day']}
                    textField={(params) => (
                      <TextField 
                        value={field.value}
                        {...params} 
                        margin="normal" 
                        sx={{width: '100%'}}
                      />
                    )}
                    slotProps={{
                      actionBar: {
                        // actions: ['today'],
                      },
                      textField: {
                        error: !!(errors?.end),
                        fullWidth: true
                      }
                    }}
                  />
                </LocalizationProvider>
              )}
            />
          </Grid>
          
          <Grid item xs={12} mt={3}>
            <Divider sx={{'::before, ::after':{borderColor: grey[200]}}} aria-hidden="true" textAlign='left'>
              <Chip label="Payment Status" size="small" sx={{borderRadius: 1, backgroundColor: grey[100]}} />
            </Divider>
          </Grid>

          <Grid item xs={12}>
            <Stack direction="row" spacing={2}>
              {paymentStatusArray.map(({name, value}) => 
                <Chip 
                  key={value}
                  sx={{borderRadius: 2}} 
                  icon={<CurrencyRupee sx={{fontSize: 18}} />} 
                  label={name} 
                  variant={paymentStatus === value ? "contained" : "outlined"}
                  color='primary'
                  onClick={() => setValue('status', paymentStatus === value ? null : value)}
                />
              )}
            </Stack>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} mt={2}>
            <Controller
              control={control}
              name="paymentType"
              id="paymentType"
              render={({field}) => (
                <FormControl {...field} fullWidth margin="normal" >
                  <InputLabel id="paymentType-label" >Payment Type</InputLabel>
                  <Select    
                    {...field}
                    defaultValue="all"
                    required
                    name="paymentType"                 
                    labelId="paymentType-label"
                    id="paymentType-select"
                    label="Payment Type"
                    value={field.value}
                   
                  >
                    <MenuItem value='all'>All</MenuItem>
                    {paymentTypeList.map(({name, value}) => <MenuItem key={value} value={value}>{name}</MenuItem>)}
                  </Select>
                </FormControl>
              )}
            />
          </Grid>   

          {/* <Grid  item xs={12} sm={12} md={12} lg={12} xl={12} mt={2} >
            <Controller
              control={control}
              name="searchText"
              id="searchText"
              render={({field}) => (
                <TextField
                  {...field}
                  margin="normal"
                  label="Search"
                  placeholder="Name or Mobile no or Date or Bed or Payment type"
                  fullWidth 
                />
              )}
            />
          </Grid> */}
        </Grid>

        <Grid item xs={12}  container alignContent="flex-end" >
          <Stack direction="row" sx={{width: '100%'}} justifyContent="space-between">
            <Box>
              <Button type="button" sx={{color: grey[600]}} onClick={resetFilters}>Reset</Button>
              <Button type="button" sx={{color: grey[600]}} onClick={closeModal}>Cancel</Button>
            </Box>
            <Button
              type="submit"
              variant="tonal"
              color="success"
              // sx={{mt:3}}
              >
              Apply
            </Button>
          </Stack>
        </Grid>
        
      </Grid>
    </Box>
  )
}

export default memo(FilterOptions);